import { Calendar } from "lucide-react";
import QuotaItem from "./QuotaItem";
import { useMemo } from "react";

const sortQuotasByPeriod = (quotas) => {
  // Mapeo de meses en español a números
  const monthOrder = {
    'enero': 1, 'febrero': 2, 'marzo': 3, 'abril': 4,
    'mayo': 5, 'junio': 6, 'julio': 7, 'agosto': 8,
    'septiembre': 9, 'octubre': 10, 'noviembre': 11, 'diciembre': 12
  };

  // Mapeo de semestres
  const semesterOrder = {
    'semestre 1': 1,
    'semestre 2': 2
  };

  return [...quotas].sort((a, b) => {
    const periodA = a.period?.toLowerCase() || '';
    const periodB = b.period?.toLowerCase() || '';
    
    // Primero ordenar por año (puede ser number o string)
    const yearA = typeof a.year === 'number' ? a.year : parseInt(a.year) || 0;
    const yearB = typeof b.year === 'number' ? b.year : parseInt(b.year) || 0;
    
    if (yearA !== yearB) {
      return yearA - yearB;
    }

    // Si ambos son meses
    if (monthOrder[periodA] && monthOrder[periodB]) {
      return monthOrder[periodA] - monthOrder[periodB];
    }

    // Si ambos son semestres
    if (semesterOrder[periodA] && semesterOrder[periodB]) {
      return semesterOrder[periodA] - semesterOrder[periodB];
    }

    // Si uno es anual, va al final
    if (periodA === 'anual' && periodB !== 'anual') return 1;
    if (periodB === 'anual' && periodA !== 'anual') return -1;

    // Orden por defecto alfabético
    return periodA.localeCompare(periodB);
  });
};
const QuotasList = ({ title, quotas, isEditable = false, onQuotaChange, emptyMessage, compact = false }) => {
  // Usar useMemo para ordenar las cuotas solo cuando cambien
  const sortedQuotas = useMemo(() => {
    return sortQuotasByPeriod(quotas);
  }, [quotas]);

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <h3 className="text-lg font-bold text-gray-900 mb-4">{title}</h3>
      
      {sortedQuotas.length === 0 ? (
        <div className="text-center py-8 text-gray-500">
          <Calendar size={48} className="mx-auto mb-4 text-gray-300" />
          <p>{emptyMessage}</p>
        </div>
      ) : (
        <div className="space-y-3 max-h-96 overflow-y-auto">
          {sortedQuotas.map((quota, index) => {
            // Encontrar el índice original para mantener la referencia correcta
            const originalIndex = quotas.findIndex(q => 
              q.id ? q.id === quota.id : 
              (q.period === quota.period && q.year === quota.year && q.amount === quota.amount)
            );
            
            return (
              <QuotaItem
                key={quota.id || `${quota.period}-${quota.year}-${index}`}
                quota={quota}
                isEditable={isEditable}
                onQuotaChange={(updatedQuota) => onQuotaChange && onQuotaChange(originalIndex, updatedQuota)}
                compact={compact}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default QuotasList;
